import { Error } from "@carbon/icons-react";
import { t } from "i18next";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";

import useCancelInboundDeliveryMutation from "../../../../hooks/graphql-hooks/mutations/useCancelInboundDeliveryMutation";
import useNavigateTo from "../../../../hooks/useNavigateTo";
import AlertDialog from "../../../alertDialog/AlertDialog";
import DeliveryAction from "../DeliveryAction";

interface DeliveryActionCancel {
  id: string;
}

const DeliveryActionCancel = (props: DeliveryActionCancel) => {
  const { id } = props;
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const { navigateToDeliveries } = useNavigateTo();

  const [cancelInboundDelivery, { loading }] = useCancelInboundDeliveryMutation(
    {
      dataAction: () => handleCancelSuccess(),
    },
  );

  const handleCancelSuccess = () => {
    setShowCancelDialog(false);
    enqueueSnackbar(t("cancelInboundDeliverySuccessful"), {
      variant: "success",
    });
    navigateToDeliveries();
  };

  const handleConfirmCancelInboundDelivery = () => {
    cancelInboundDelivery({
      variables: { cancelInboundDeliveryInput: { id } },
    }).catch(() => {});
  };

  return (
    <>
      <DeliveryAction
        icon={<Error size={24} />}
        label={t("cancelInboundDelivery")}
        onClick={() => setShowCancelDialog(true)}
      />
      {showCancelDialog && (
        <AlertDialog
          showDialog={showCancelDialog}
          setShowDialog={() => setShowCancelDialog(false)}
          headerLogo={
            <Error
              className="alert-dialog-container-head-alert-header-top-half-mid-ellipse-icon"
              size={32}
            />
          }
          title={t("cancelInboundDelivery") + "?"}
          description={t("cancelInboundDeliveryAlertDialogDescription")}
          confirmButtonText={t("confirmCancelInboundDelivery")}
          cancelButtonText={t("no")}
          handleConfirm={handleConfirmCancelInboundDelivery}
          type="warning"
          confirmButtonDisabled={loading}
          isLoading={loading}
        />
      )}
    </>
  );
};
export default DeliveryActionCancel;
